/**
 * Plateforme multi evenement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.connexionObligatoire.ts
 *
 * Messages du chantier du 2026-10-04 (demandes de Mika) :
 *   - connexion obligatoire (`access.login_required`, V141) : réglage du
 *     back-office, message de la page des listes quand le serveur répond 401 ;
 *   - signalement du mode aperçu administrateur ;
 *   - liens vers les pages d'information sur l'écran de pré-ouverture ;
 *   - ouverture du scan réel le seul jour de l'événement
 *     (`scan.ouvert_hors_evenement`, V141).
 * Vocabulaire de l'événement par jetons ({lexExhibitor…}), jamais en dur.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesConnexionObligatoireFr: Record<string, string> = {
  // ── Mode aperçu administrateur ─────────────────────────────────────────
  'connexionObligatoire.apercuAdmin':
    'Aperçu administrateur : les visiteurs ne voient pas cette page.',

  // ── Listes de la vitrine, réponse 401 `login_required` ────────────────
  'connexionObligatoire.liste.titre': 'Réservé aux personnes inscrites',
  'connexionObligatoire.liste.postes': 'Connectez-vous pour voir les offres.',
  'connexionObligatoire.liste.exposants': 'Connectez-vous pour voir la liste {lexExhibitorOfPlural}.',
  'connexionObligatoire.liste.programme': 'Connectez-vous pour voir le programme.',
  'connexionObligatoire.liste.bouton': 'Se connecter',
  'connexionObligatoire.liste.inscription': 'Pas encore de compte ? S’inscrire',

  // ── Pages d'information, sur l'écran de pré-ouverture ──────────────────
  'connexionObligatoire.liens.aria': 'Pages d’information',
  'connexionObligatoire.liens.contact': 'Contact',
  'connexionObligatoire.liens.mentions': 'Mentions légales',
  'connexionObligatoire.liens.confidentialite': 'Confidentialité',
  'connexionObligatoire.liens.accessibilite': 'Accessibilité',

  // ── Back-office : /admin/settings ──────────────────────────────────────
  'settingsAdmin.loginRequired.label': 'Connexion obligatoire',
  'settingsAdmin.loginRequired.help':
    'Cochée : seuls l’accueil, l’inscription, la connexion et les pages d’information sont visibles sans compte. Décochée : tout visiteur peut consulter les {lexExhibitorPlural}, les offres et le programme sans compte.',
  'settingsAdmin.superAdminOnly': 'Modification réservée au super-administrateur.',
  'settingsAdmin.scanOuvert.label': 'Scan des badges',
  'settingsAdmin.scanOuvert.auto': 'Automatique : jour J seulement',
  'settingsAdmin.scanOuvert.test': 'Ouvert maintenant pour test',
  'settingsAdmin.scanOuvert.help':
    'Automatique : le scan réel des badges (stand, contrôle, émargement, contrôle d’accès) ne fonctionne que le jour de l’événement. Ouvert maintenant : pour un test, à remettre sur Automatique ensuite. Le mode découverte reste disponible avant l’événement dans les deux cas.',

  // ── Back-office : Étape (verrous individuels) ──────────────────────────
  'pilotage.lock.loginRequired.label': 'Connexion obligatoire',
  'pilotage.lock.loginRequired.hint':
    'Cochée : seuls l’accueil, l’inscription, la connexion et les pages d’information sont visibles sans compte. Décochée : tout visiteur peut consulter les {lexExhibitorPlural}, les offres et le programme sans compte.',
  // 2026-10-05 (Mika : « il ne peut pas y avoir d'ambiguïté ») : le libellé
  // dit « réel », le choix de test dit qu'il enregistre pour de bon.
  // Mikael - chef de projet - 2026-10-05
  'pilotage.lock.scanBadges.label': 'Scan RÉEL des badges',
  'pilotage.lock.scanBadges.hint':
    'Automatique : le scan réel (stand, contrôle, émargement) ne fonctionne que le jour J, de l’heure de début à l’heure de fin. Ouvert maintenant : pour un test, chaque vrai badge scanné est alors enregistré pour de bon ; remettez Automatique ensuite. Le mode entraînement (badges de test) n’en dépend pas.',
  'pilotage.lock.scanBadges.auto': 'Automatique : jour J seulement',
  'pilotage.lock.scanBadges.test': 'Ouvert maintenant pour un test (enregistre les vrais badges)',
  'pilotage.lock.scanBadges.ouvert': 'En ce moment : le scan réel est OUVERT.',
  'pilotage.lock.scanBadges.ferme': 'En ce moment : le scan réel est fermé.',
  'pilotage.lock.absent': 'Réglage absent sur cette instance : appliquez la migration V141.',

  // ── Scan réel avant le jour J ──────────────────────────────────────────
  'scanOuverture.ferme.titre': 'Le scan s’ouvre le jour de l’événement',
  'scanOuverture.ferme.texte':
    'Le jour J, cet écran enregistrera les badges des participants. En attendant, entraînez-vous avec le mode découverte : des badges d’essai, rien n’est enregistré.',
  'scanOuverture.ferme.bouton': 'Ouvrir le mode découverte',
  'scanOuverture.ferme.sansDecouverte':
    'Le mode découverte n’est pas ouvert pour le moment. Revenez le jour J.',
  // 2026-10-05 : dit qu'un VRAI badge a été lu et refusé, et que rien n'est
  // enregistré. Mikael - chef de projet - 2026-10-05
  'scanOuverture.ferme.toast':
    'Vrai badge refusé : le scan réel s’ouvre le jour J, rien n’a été enregistré. En attendant, entraînez-vous avec les badges de test.',
  'scanOuverture.controle.titre': 'Le contrôle des badges s’ouvre le jour de l’événement',
  'scanOuverture.controle.texte':
    'Revenez sur cet écran le jour J : la caméra s’activera pour l’émargement et les contrôles.',
  'scanOuverture.controle.toast': 'Le contrôle des badges s’ouvre le jour de l’événement.',
};
